const isFunction = (input) => typeof input === 'function';

export default (predicate) => (elemOrThunk) => {
  if (!predicate) return null;
  return isFunction(elemOrThunk)
    ? elemOrThunk()
    : elemOrThunk;
};
